import service, { setAuthorizationToken } from '../config/axios.config';

export const login = async({ loginName, password }) => {
  localStorage.removeItem('jwtToken');

  const url = '/login';

  try {
    const response = await service.post(url, { loginName, password });
    const { token } = response.data;

    localStorage.setItem('jwtToken', token);

    setAuthorizationToken(token);
  } catch (error) {
    throw error;
  }
};

export const logout = async () => {
  localStorage.removeItem('jwtToken');

  setAuthorizationToken('');
};
